/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ComponentType {
    Text = 0,
    Button = 1,
    LanguageSelect = 2,
    LookupForm = 3,
    Screensaver = 4,
    AccountSelection = 5,
    Confirm = 6,
    Balances = 7,
    PaymentMethods = 8,
    CashPayment = 9,
    CheckPayment = 10,
    ReceiptInput = 11,
    PayorInformationForm = 12,
    CardPaymentMagTek = 13,
    ThankYou = 14,
    CardPaymentEMV = 15,
    ReceiptDigital = 16,
    ReceiptPrint = 17,
    ScrollableText = 18,
    CardPaymentEmvMock = 19,
    SubTitle = 20,
    Image = 21,
    MessageBox = 22,
    CheckPaymentWithManualEntry = 23,
    CardPaymentToken = 24,
}
